export const FETCH_COUNTRIES = 'search/FETCH_COUNTRIES';
export const FETCH_LOCATIONS = 'search/FETCH_LOCATIONS';
export const FETCH_USER_LOCATION = 'search/FETCH_USER_LOCATION';
export const SET_MOCK_LOCATION = 'search/SET_MOCK_LOCATION';
export const SET_SCREEN_TYPE = 'search/SET_SCREEN_TYPE';
export const POST_SEARCH = 'search/POST_SEARCH';
export const SET_COUNTRY = 'search/SET_COUNTRY';
export const SET_CURRENCY = 'search/SET_CURRENCY';
export const SET_DRIVER_AGE = 'search/SET_DRIVER_AGE';
export const SET_DROPOFF_DATE = 'search/SET_DROPOFF_DATE';
export const SET_DROPOFF_DIFFERENT = 'search/SET_DROPOFF_DIFFERENT';
export const SET_DROPOFF_LOCATION = 'search/SET_DROPOFF_LOCATION';
export const SET_DROPOFF_TIME = 'search/SET_DROPOFF_TIME';
export const SET_GUEST_TOKEN = 'search/SET_GUEST_TOKEN';
export const SET_PASSENGERS = 'search/SET_PASSENGERS';
export const SET_PICKUP_DATE = 'search/SET_PICKUP_DATE';
export const SET_PICKUP_LOCATION = 'search/SET_PICKUP_LOCATION';
export const SET_PICKUP_TIME = 'search/SET_PICKUP_TIME';
export const SET_PROMO_CODE = 'search/SET_PROMO_CODE';
export const SET_QUOTE_ID = 'search/SET_QUOTE_ID';
export const SET_SEARCH_STATE = 'search/SET_SEARCH_STATE';
export const SET_TRANSMISSION = 'search/SET_TRANSMISSION';
export const SET_AGENT_ID = 'search/SET_AGENT_ID';
export const SET_BOOKING_REFERENCE = 'search/SET_BOOKING_REFERENCE';
export const CLEAR_SEARCH = 'search/CLEAR_SEARCH';
export const USER_DEV_LOCATION = 'search/USER_DEV_LOCATION';
export const SET_UPDATE_QUOTE = 'search/SET_UPDATE_QUOTE';
export const SET_CANCEL_DONATION = 'search/SET_CANCEL_DONATION';
export const SET_LAST_NAME = 'search/SET_LAST_NAME';
export const SET_RECREATE_QUOTE = 'search/SET_RECREATE_QUOTE';
